module.exports = __webpack_public_path__ + "static/media/cell-based-therapies.625d49a1.jpg";